import { render, staticRenderFns } from "./retratoFuncional.vue?vue&type=template&id=3227f833&scoped=true&"
import script from "./retratoFuncional.vue?vue&type=script&lang=js&"
export * from "./retratoFuncional.vue?vue&type=script&lang=js&"
import style0 from "./retratoFuncional.vue?vue&type=style&index=0&id=3227f833&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3227f833",
  null
  
)

export default component.exports